import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-227e689a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "viewPort" }
const _hoisted_2 = { id: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "branding_in" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nordly"),
  /*#__PURE__*/_createTextVNode(" accounts")
], -1))
const _hoisted_4 = { class: "shortCuts_list" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Profile")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Security")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Devices")
const _hoisted_9 = { class: "right_header_wrapper" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { id: "accountOptions_grid" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "profile_Img",
  src: "https://cdn-istatics.herokuapp.com/static/imgs/defaultProfile/profile_default_blue.png",
  alt: "profile imagem"
}, null, -1))
const _hoisted_13 = { class: "profile_displayName" }
const _hoisted_14 = { class: "profile_mail" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"options recover\" data-v-227e689a></div><div class=\"options privacity\" data-v-227e689a></div><div class=\"options security\" data-v-227e689a></div><div class=\"options local\" data-v-227e689a></div><div class=\"options services\" data-v-227e689a></div>", 5)
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "titles_wrapper" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Your Devices"),
  /*#__PURE__*/_createElementVNode("p", { class: "description" }, " You’re currently signed in to your Nordly Account on these devices. ")
], -1))
const _hoisted_21 = { class: "devices_list" }
const _hoisted_22 = { class: "device_icon-wrapper" }
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "device_infors" }
const _hoisted_25 = { class: "device_infors-os" }
const _hoisted_26 = { class: "device_infors-location" }
const _hoisted_27 = {
  key: 0,
  class: "matched_device"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "This device", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives(_createElementVNode("header", _hoisted_2, [
      _createVNode(_component_router_link, { to: "myaccount" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: "myaccount",
          class: "shortCuts"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "profile",
          class: "shortCuts"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "",
          class: "shortCuts"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "",
          class: "shortCuts"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          id: "logout_btn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
        }, "Log out"),
        _createElementVNode("img", {
          class: "headerIcon",
          src: _ctx.iconUrl('account_circle')
        }, null, 8, _hoisted_10)
      ])
    ], 512), [
      [_vShow, true]
    ]),
    _createElementVNode("section", _hoisted_11, [
      _createVNode(_component_router_link, {
        to: "profile",
        class: "options profile"
      }, {
        default: _withCtx(() => [
          _hoisted_12,
          _createElementVNode("h1", _hoisted_13, _toDisplayString(_ctx.username), 1),
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.mail), 1)
        ]),
        _: 1
      }),
      _hoisted_15,
      _createVNode(_component_router_link, {
        to: "devices",
        class: "options devices"
      }, {
        default: _withCtx(() => [
          _hoisted_20,
          _createElementVNode("section", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devices, (device, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: device.ip,
                class: "device"
              }, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("img", {
                    class: "device_icon",
                    src: _ctx.iconUrl('device_unknown', 'black'),
                    alt: "Device Icon"
                  }, null, 8, _hoisted_23)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("h3", _hoisted_25, _toDisplayString(device.os.split(" ")[0]), 1),
                  _createElementVNode("p", _hoisted_26, _toDisplayString(device.location), 1),
                  (index === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _createElementVNode("div", null, [
                          _createElementVNode("img", {
                            id: "matched_icon",
                            src: _ctx.iconUrl('check_circle', 'black'),
                            alt: "Matched deviced"
                          }, null, 8, _hoisted_28)
                        ]),
                        _hoisted_29
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ])
  ]))
}